import { BigQueryTimestamp } from '@google-cloud/bigquery';

export enum AssetItemTypes {
  CORPORATE = 'Corporate',
  GOVERNMENT = 'Government',
}

export interface AssetItemDB {
  AssetID: string;
  AssetName: string;
  AssetDescription: string;
  OrganizationID: number;
  ImpactRadius: number | null;
  Latitude: number;
  Longitude: number;
  Headcount: number;
  Icon?: string;
  Photo: string;
  Country: string;
  City: string;
  Address: string;
  Phone: string;
  FocalPointName: string | null;
  FocalPointEmail: string | null;
  FocalPointPhone: string | null;
  DataSource: string;
  Hyperlink: string;
  ReportLink: string;
  AssetType?: AssetItemTypes | null; // optional
  SupplyChainMapping?: string | null; // external URL; populated per org by the view (data-driven)
}

export interface IncidentItemDB {
  IncidentID: string;
  IncidentSourceId: number;
  IncidentDateTime: BigQueryTimestamp;
  Title: string;
  Tags?: string; // joined array of IncidentTagItemDB['IncidentTagsName'];
  IncidentDescription: string;
  IncidentTypeID: IncidentTypeItemDB['IncidentTypeID'];
  IncidentTypeName: IncidentTypeItemDB['IncidentTypeName'];
  IncidentTypeRelevance: string;
  Latitude: number;
  Longitude: number;
  Photo?: string;
  Country: string;
  City: string;
  Address: string;
  Region: string;
  SeverityLevel: SeverityItemDB['SeverityID'];
  Hyperlink: string;
  DataSource: string;
  messageGuidOrig: string;
  eventCode: string;
  publish_time: string;
  VerificationSource?: string | null;
  Industry?: string | null;
  GSI?: number | null;
  SupplyChainMapping?: string | null; // external URL; populated per org by the view (data-driven)
}

export interface IncidentTypeItemDB {
  IncidentTypeID: string; // '1', '1.1', ... '5', ...
  IncidentTypeName: string;
  IncidentTypeCategory: string;
}

export interface IncidentTagItemDB {
  IncidentTagsID: string;
  IncidentTagsName: string;
  BackgroundColor: string;
}

export interface SeverityItemDB {
  SeverityID: number;
  SeverityName: string;
}
